import { createReducer, on } from '@ngrx/store';

import { IUiState } from '@shared/types/ui/ui.type';

import { check_user_auth_failure } from '../actions/session.action';
import {
    disable_content_loader,
    enable_content_loader,
    force_disable_content_loader,
    init_app,
    select_sidebar_item,
    set_menu_items,
} from '../actions/ui.action';

const initialState: IUiState = {
    loader: false,
    contentLoader: false,
    menuItems: [],
    selectedMenuItem: null,
    pendingRequests: 0,
};

const addPendingRequest = (pendingRequests) => {
    return pendingRequests + 1;
};

const subtractPendingRequest = (pendingRequests) => {
    if (pendingRequests > 0) {
        return pendingRequests - 1;
    }
    return pendingRequests;
};

const _uiReducer = createReducer(
    initialState,
    on(
        init_app,
        (state): IUiState => ({ ...state, loader: true, pendingRequests: addPendingRequest(state.pendingRequests) }),
    ),
    on(select_sidebar_item, (state, { selectedMenuItem }): IUiState => ({ ...state, selectedMenuItem })),
    on(check_user_auth_failure, (state): IUiState => state),

    on(set_menu_items, (state, { menuItems }): IUiState => ({ ...state, menuItems })),

    on(
        enable_content_loader,
        (state): IUiState => ({
            ...state,
            loader: true,
            pendingRequests: addPendingRequest(state.pendingRequests),
        }),
    ),
    on(
        disable_content_loader,
        (state): IUiState => ({
            ...state,
            loader: subtractPendingRequest(state.pendingRequests) !== 0,
            pendingRequests: subtractPendingRequest(state.pendingRequests),
        }),
    ),
    on(
        force_disable_content_loader,
        (state): IUiState => ({
            ...state,
            loader: false,
            pendingRequests: 0,
        }),
    ),
);

export function uiReducer(state, action) {
    return _uiReducer(state, action);
}
